var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{ref:"textarea",attrs:{"id":"codemirror_text_area"},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }